import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import exp from 'constants';
import styled from 'styled-components';
import {DEFAULT_TABLE_COLOR} from '../../GlobalStyles';
// =========================
// TABLE LAYOUT & CONTAINER
// =========================

export const Table = styled.table<{ color?: string }>`
  width: 100%;
  border-collapse: collapse;
  margin: 20px 0;
  th { 
    border: 1px solid ${({ color }) => color || DEFAULT_TABLE_COLOR};
    padding: 20px 12px;
  }
  td {
    border: 1px solid ${({ color }) => color || DEFAULT_TABLE_COLOR};
  }
`;

export const TableContainer = styled.div`
  position: relative;
`;

export const TableHeader = styled.div`
  position: relative;
  height: 100px; 
  align-items: left;
`;

// =========================
// TABLE STRUCTURE ELEMENTS
// =========================

export const Thead = styled.thead`
  background-color: #f2f2f2;
`;

export const Tbody = styled.tbody``;

export const Tr = styled.tr`
  &:nth-child(even) {
    background-color: #EFEFEF;
  }
`;

export const TrNoWrap = styled(Tr)`
  white-space: nowrap;
`;

export const Th = styled.th<{ width?: string; bgColor?: string }>`
  background: ${({ bgColor }) => bgColor || '#42484f'};
  color: #fff;
  font-weight: 600;
  ${({ width }) => width && `width: ${width};`}
`;

export const Td = styled.td`
    padding: 8px;

`;

// =========================
// SPECIALIZED TABLE CELLS
// =========================

export const DataTd = styled(Td)`
  text-align: right;
`;

export const NarrowTd = styled(Td)`
  text-align: center;
  vertical-align: middle;
`;

// ============================
//       HEADER ELEMENTS
// ============================

export const HeaderContentWrapper = styled.div<{ isCentered?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: ${({ isCentered }) => (isCentered ? 'center' : 'space-between')};
  width: 100%;
  height: 100%;
`;

export const HeaderCenterContent = styled.span`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  padding: 0 10px;
`;

export const HeaderText = styled.span`
  flex: 1;
  text-align: center;
  font-weight: bold;
  font-size: 16.66px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const SortIconsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const GeneralHeaderIcon = styled(FontAwesomeIcon)`
  font-size: 18px;
  line-height: 1;
`;

export const InteractiveHeaderIconStyles = styled(FontAwesomeIcon)<{ active?: boolean; onClick?: any; bgColor?: string }>`
  color: ${({ active, bgColor }) => (active ? 'black' : (bgColor || DEFAULT_TABLE_COLOR))};
  background-color: ${({ active }) => (active ? '#EFAB66' : '#f2f2f2')};
  font-size: 16px;
  line-height: 1;
  padding: 4px;
  transition: background-color 0.2s, color 0.2s, border 0.2s, border-radius 0.2s, cursor 0.2s;
  cursor: ${({ onClick }) => (onClick ? 'pointer' : 'default')};
  border: ${({ active }) => (active ? '2px solid #f2f2f2' : '2px solid transparent')};
  border-radius: 4px;
  &:hover {
    background-color: #f0be8cff;
    color: #636363 !important;
    border: 2px solid white;
    cursor: ${({ onClick }) => (onClick ? 'pointer' : 'default')};
  }
`;



// ============================
//         SEARCH POPUP
// ============================


export const SearchPopup = styled.div`
  position: absolute;
  bottom: 2px; /* Adjust as needed */
  left: 50%;
  transform: translateX(-50%);
  background: rgba(205, 219, 249, 0.9);
  border: 1px solid #ccc;
  padding: 16px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  z-index: 1000;
`;

export const SearchInput = styled.input`
  margin-right: 8px;
  width: 400px;
`;


